export const homeObjOne = {
  headline: "ژانر وحشت",
  description:
    "در زبان انگلیسی به این ژانر Horror یا همان احساس شدید ترس یا ناامیدی می‌گویند. به گفته‌ی آقای «J. A. Cuddon»، تاریخ‌شناس و نویسنده‌ی انگلیسی، این ژانر با استفاده از مواردی که از دیرباز برای مردم ترسناک بوده است، نظیر ایجاد یک اتمسفر تاریک با صداسازی ترس‌ناک، استفاده از موجودات ماوراءالطبیعه نظیر بیگانگان، ارواح، شیاطین و موجوداتی خیالی نظیر خون‌آشامان سعی در به وجود آوردن حس ترس و دلهره در مخاطب می‌کنند. این ژانر دارای اصولی است که منجر به ایجاد ترس می‌شود و معمولا در صنعت سینما با صنعت چاپ کتاب، تقریبا متفاوت است. به عنوان مثال: «در ادبیات ژانر وحشت، تصور خیال دقیق نویسنده بر فضا و اتمسفر داستان، علت اصلی ایجاد ترس و دلهره‌ی خواننده خواهد شد».",
  imgStart: "",
  img: require("./images/hero.png").default,
  alt: "کتاب های ترسناک",
  start: "",
};
